// src/hooks/useUsers.js
import { useState, useEffect } from 'react';
import { getInitialMatches } from '../services/UserService'; // Assuming this is your API service

export const useUsers = (userProfile, user) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadUsers = async () => {
      if (!userProfile) return;

      try {
        setLoading(true);
        const response = await getInitialMatches();
        console.log("useusers hook -> initial users", response)
        const filteredUsers = response.data.content.filter((u) => u.id !== user.id);
        setUsers(filteredUsers);
        setError(null);
      } catch (err) {
        setError('Failed to load users');
      } finally {
        setLoading(false);
      }
    };

    loadUsers();
  }, [userProfile, user]);

  return { users, loading, error }; // Return an object
};
